import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalDataService {
  public iterationSelectionEvent = new EventEmitter<any>();
  public outingSelectionEvent = new EventEmitter<any>();
  public routeEvent = new EventEmitter<any>();
  public postLoginEvent = new EventEmitter<any>();
  public postDashboardLoadEvent = new EventEmitter();
  public themeChangeEvent = new EventEmitter<boolean>();
  
  constructor() { }
}
